import { render, staticRenderFns } from "./RegisterProviderError.vue?vue&type=template&id=5ccb1a6e&"
import script from "./RegisterProviderError.vue?vue&type=script&lang=js&"
export * from "./RegisterProviderError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports